import React from 'react'

import styles from './TableHeader.css'
import { SORT_TYPES } from '../../../../constants'
import SortIcon from '../../../../../static/images/sortIcon.svg'

const TableHeader = props => {
  const {
    enableSort = true,
    label,
    filterActive,
    columnHeader,
    handleOnFilterButtonClick,
    handleOnSortClick,
    lastElement,
    sortBy,
    sortDirection,
    selectedPopover,
    Popover,
    noFilterPlaceholder = false,
    disable = false,
  } = props

  const cn = !lastElement ? styles.columnFilter : styles.lastColumnFilter
  const activeCn = !filterActive ? styles.filterButton : styles.filterButtonActive

  let sortDirectionIcon = <div className={styles.sortDirectionNone} />

  if (enableSort && sortBy === columnHeader) {
    switch (sortDirection) {
    case SORT_TYPES.DESC:
      sortDirectionIcon = (
        <div className={styles.sortDirectionDesc} />
      )
      break
    case SORT_TYPES.ASC:
      sortDirectionIcon = (
        <div className={styles.sortDirectionAsc} />
      )
      break
    case null:
    default:
      break
    }
  }

  return (
    <div className={styles.headerWithControls}>
      {enableSort && (
        <div
          className={styles.columnHeader}
          onClick={() => handleOnSortClick(columnHeader)}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div style={{ marginLeft: '14px' }}>{label}</div>
          <div style={{ marginRight: '14px' }}>
            {sortDirectionIcon}
            <SortIcon />
          </div>
        </div>
      )}
      {!enableSort && (
        <div
          className={styles.columnHeaderNoSort}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div style={{ marginLeft: '14px' }}>{label}</div>
          <div style={{ marginRight: '14px' }}>
            <SortIcon />
          </div>
        </div>
      )}
    </div>
  )
}

export default TableHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/Crpcomponents/TableHeader/TableHeader.jsx